import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../Service/Baseservice";
import CalendarIcon from "../../Assets/img/calendar.png";
import CharIcon from "../../Assets/img/word.png";
import UploadIcon from "../../Assets/img/upload.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BlogPreview from "./Blogpreview";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const BlogAdd = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        language_id: "",
        author_name: "",
        heading: "",
        description: "",
        blog_date: "",
        blog_image: "",
        blogseo_id: "", 
        blog_tag_id: [], 
        createdBy: 1,
        updatedBy: 1,
    });
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });

    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [uploadedUrl, setUploadedUrl] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPreviewBlog, setShowPreviewBlog] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const MAX_CHARS = 80000;

    const [lastValidDescription, setLastValidDescription] = useState("");

    // --- Blog Tag Dropdown States ---
    const [tagOptions, setTagOptions] = useState([]);
    const [selectedTag, setSelectedTag] = useState([]);
    const [servicesList, setServicesList] = useState([]);
    const [selectedService, setSelectedService] = useState("");
    const observer = new ResizeObserver(entries => {
        try {
            for (let entry of entries) {

            }
        } catch (err) {
            console.error(err);
        }
    });


    useEffect(() => {
        if (!formData.language_id) return;

        const payload = {
            search: "",
            status: "active",
            language_id: formData.language_id,
        };

        API.post("blogtag_list/condition", payload)
            .then((res) => {
                const tagArray = res?.data?.data?.data;
                if (Array.isArray(tagArray)) {
                    const formatted = tagArray.map((tag) => ({
                        value: tag.blog_tag_id,
                        label: tag.blogtag.trim(),
                    }));
                    setTagOptions(formatted);
                } else {
                    console.warn("Tag list not found or invalid format:", res);
                }
            })
            .catch((err) => console.error("Error fetching blog tags:", err));
    }, [formData.language_id]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "heading" && getPlainTextLength(value) > 100) return;
        setFormData({ ...formData, [name]: value });
    };

    const handlePreview = () => {
        if (!formData.heading || !formData.description || !formData.blog_date) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all fields to preview",
                type: "info",
            });
            return;
        }

        setPreviewData({
            ...formData,
            blog_id: "preview",
            blog_image: imagePreview,
        });
        setShowPreviewBlog(true);
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent?.length || 0;
    };
    // setTimeout(() => {
    //     window.dispatchEvent(new Event('resize'));
    // }, 300);

    const handleSubmit = () => {
        if (
            !formData.heading ||
            !formData.description ||
            !formData.blog_date ||
            !formData.author_name ||
            !imageFile
        ) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all fields to Add Blog",
                type: "info",
            });
            return;
        }
        if (!formData.language_id) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please select a language",
                type: "info",
            });
            return;
        }

        setIsSubmitting(true);
    };

    useEffect(() => {
        if (isSubmitting && imageFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                const imagePayload = {
                    name: imageFile.name,
                    image: [
                        {
                            name: imageFile.name,
                            type: imageFile.type,
                            size: `${imageFile.size} bytes`,
                            base64: base64Image,
                        },
                    ],
                };
                API.post("imageUpload/add", imagePayload)
                    .then((res) => {
                        const url = res.data?.url;
                        setUploadedUrl(url);
                    })
                    .catch((err) => {
                        console.error("Image upload failed:", err);
                        setPopup({
                            show: true,
                            title: "Warning",
                            message: "Image upload failed",
                            type: "info",
                        });
                        setIsSubmitting(false);
                    });
            };
            reader.readAsDataURL(imageFile);
        }
    }, [isSubmitting, imageFile]);

    useEffect(() => {
        if (uploadedUrl && isSubmitting) {
            const blogPayload = { ...formData, blog_image: uploadedUrl };
            API.post("add_blogs/add", blogPayload)
                .then(() => {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: "Blog added successfully!",
                        type: "success",
                    });
                    // setTimeout(() => navigate("/blog"), 3500);
                })
                .catch((err) => {
                    console.error("Failed to add blog:", err);
                    setPopup({
                        show: true,
                        title: "Failed",
                        message: "Failed to add blog",
                        type: "failed",
                    });
                })
                .finally(() => setIsSubmitting(false));
        }
    }, [uploadedUrl, isSubmitting]);
    const fetchServices = () => {
        API.post("blogseo_list/condition", { language_id: formData.language_id })
            .then((res) => {
                const active = (res?.data?.data?.data || [])
                    .filter((x) => x.active === 1 || x.active === "1")
                    .sort((a, b) => Number(a.order_by) - Number(b.order_by));
                setServicesList(active);
            })
            .catch((err) => console.error("Service load error:", err));
    };
    useEffect(() => {
        fetchServices();
    }, [formData.language_id]);
    return (
        <div className="newss-containeradd">
            {/* Header */}
            <div className="blogadd-header">
                <h2 className="newss-title">Add Blog</h2>
                <div className="header-buttons">
                    <button onClick={handlePreview} className="btn saves-btn">
                        Preview
                    </button>
                    <button onClick={handleSubmit} className="btn saves-btn">
                        Save
                    </button>
                    <button onClick={() => navigate("/blog")} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            {/* Form Wrapper */}
            <div className="blogadd-form-wrapper">
                {/* Left Side */}
                <div className="blogadd-left-card">
                    <div className="upload-section">
                        <label>
                            Upload Image <span className="required">*</span>
                        </label>
                        <div className="upload-box">
                            {imagePreview ? (
                                <img src={imagePreview} alt="Preview" className="preview-img" />
                            ) : (
                                <>
                                    <img src={UploadIcon} alt="Upload" className="upload-icon" />
                                    <p>Click to upload</p>
                                </>
                            )}
                            <input type="file" accept="image/*" onChange={handleImageUpload} />
                        </div>
                    </div>

                    <div className="form-group2">
                        <label>
                            Author Name <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            name="author_name"
                            placeholder="Enter author name"
                            value={formData.author_name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group2">
                        <label >Language <span className="required">*</span></label>
                        <select
                            name="language_id"
                            value={formData.language_id ?? ""}
                            onChange={handleChange}
                        >
                            <option value="">Select Language</option>
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>

                    <div className="form-group2">
                        <label>
                            Date <span className="required">*</span>
                        </label>
                        <div className="date-wrapper1">
                            <input
                                type="date"
                                name="blog_date"
                                value={formData.blog_date}
                                onChange={handleChange}
                                onClick={(e) => e.target.showPicker?.()}
                            />
                            <img
                                src={CalendarIcon}
                                alt="Calendar"
                                className="calendar-blog-icon"
                                onClick={() =>
                                    document.querySelector('input[type="date"]').showPicker?.()
                                }
                            />
                        </div>
                    </div>
                </div>

                {/* Right Side */}
                <div className="blogadd-right-card">
                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Heading <span className="required">*</span>
                            </span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {getPlainTextLength(formData.heading)}/100
                                </span>
                            </div>
                        </label>
                        <input
                            type="text"
                            name="heading"
                            placeholder="Enter heading"
                            value={formData.heading}
                            onChange={handleChange}
                        />
                    </div>
                    {/* <div className="form-group">
                        <label className="description-label">Blog Service Name</label>
                        <select
                            value={selectedService}
                            onChange={(e) => {
                                const value = Number(e.target.value);

                                setSelectedService(value);

                                setFormData((prev) => ({
                                    ...prev,
                                    blogseo_id: value,
                                }));
                            }}
                        >
                            <option value="">Select Service</option>

                            {servicesList.map((service) => (
                                <option
                                    key={service.blogseo_id}
                                    value={service.blogseo_id}
                                >
                                    {service.heading}
                                </option>
                            ))}
                        </select>
                    </div> */}
                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Tag <span className="required">*</span>
                            </span>
                        </label>
                        <CreatableSelect
                            isMulti
                            options={tagOptions}
                            value={selectedTag}
                            onChange={(options) => {
                                setSelectedTag(options);
                                setFormData({
                                    ...formData,
                                    blog_tag_id: options.map((opt) => opt.value),
                                });
                            }}
                            placeholder="Select or type to add tag..."
                            isSearchable
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderColor: "#ccc",
                                    boxShadow: "none",
                                    width: "100%",
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                            formatCreateLabel={(inputValue) => `+ Add new tag "${inputValue}"`}
                        />
                    </div>

                    <div className="form-group">
                        <label className="description-label" style={{ marginBottom: "16px" }}>
                            <span className="label-text">
                                Description <span className="required">*</span>
                            </span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {getPlainTextLength(formData.description)}/80000
                                </span>
                            </div>
                        </label>

                        {/*CKEditor replacing ReactQuill */}
                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.description}

                            onChange={(event, editor) => {
                                const html = editor.getData();

                                const div = document.createElement("div");
                                div.innerHTML = html;
                                const text = div.textContent || "";

                                if (text.length <= MAX_CHARS) {
                                    // ✅ accept typing & paste
                                    setLastValidDescription(html);
                                    setFormData(prev => ({
                                        ...prev,
                                        description: html
                                    }));
                                } else {
                                    // ❌ revert extra paste/typing
                                    editor.setData(lastValidDescription);
                                }
                            }}

                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                        />





                    </div>
                </div>
            </div>

            {/* Preview Modal */}
            {showPreviewBlog && (
                <BlogPreview
                    previewBlog={previewData}
                    setShowPreviewBlog={setShowPreviewBlog}
                />
            )}

            {/* Popup Notification */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/blog");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BlogAdd;
